import { apiRequest } from "./client";

/** Adds an email to the newsletter list; the endpoint is idempotent for already-subscribed addresses. */
export const subscribeToNewsletter = (email: string): Promise<void> =>
	apiRequest<void>("/newsletter/subscribe", { method: "POST", body: { email } });

/** Takes an email off the newsletter list; succeeds the same way whether or not it was subscribed. */
export const unsubscribeFromNewsletter = (email: string): Promise<void> =>
	apiRequest<void>("/newsletter/unsubscribe", { method: "POST", body: { email } });
